import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <h1>Willkommen im Dashboard</h1>
    </div>
  );
};

export default Dashboard;
